import React, { useCallback } from 'react'
import PropTypes from 'prop-types'

import { MenuSearch } from '@fs/zion-icon'
import { useContainerWidth, H1 } from '@fs/zion-ui'

import { debounceHelper } from 'helpers'
import useSyncedValue from 'hooks/useSyncedValue'
import DashboardHeader from '../DashboardHeader/DashboardHeader'
import SearchBox from '../SearchBox/SearchBox'
import BackToRecordsHomeButton from '../BackToRecordsHomeButton/BackToRecordsHomeButton'

import transl from './CameraProjectDashboardHeader.transl'

export default function CameraProjectDashboardHeader({ filter, setFilter, title, searchBoxKey }) {
  const atWidth = useContainerWidth()
  const [searchInput, setSearchInput] = React.useState(() => '')

  const setStoredValue = useCallback(
    (storedValue) => {
      setSearchInput(storedValue)
      setFilter(storedValue)
    },
    [setFilter]
  )

  useSyncedValue({ databaseKey: searchBoxKey, value: filter, setValue: setStoredValue })

  const searchBoxProps = {
    Icon: MenuSearch,
    onChange: (event) => {
      setSearchInput(event.target.value)
      debounceHelper(setFilter, 200, [event.target.value])
    },
    onClear: () => setFilter(''),
    placeholder: transl.search(),
    type: 'search',
    value: searchInput,
    key: 'searchBox',
  }

  return (
    <DashboardHeader gridColumns={atWidth({ default: [12, 12, 12], xl: [12, 6, 6] })}>
      <BackToRecordsHomeButton />
      <H1 size="H4" key="header">
        {title}
      </H1>
      <SearchBox {...searchBoxProps} />
    </DashboardHeader>
  )
}

CameraProjectDashboardHeader.propTypes = {
  setFilter: PropTypes.func,
  title: PropTypes.string,
}
